export function ErrorView({ error, onRetry }: { error: Error; onRetry?: () => void }) {
  return (
    <div className="flex flex-col items-center gap-3 p-6 text-center">
      <div className="text-4xl">⚠️</div>
      <p className="text-tg-text">{error.message || 'Помилка завантаження'}</p>
      {onRetry && (
        <button onClick={onRetry} className="btn-secondary mt-2">
          Спробувати ще раз
        </button>
      )}
    </div>
  );
}
